import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import removeAccents from "remove-accents";
import { fetchServices, getServiceById } from "../../../../../actions/services-api";
import { useDispatch, useSelector } from "react-redux";
import { SearchService } from "./searchService";
import { Box } from "./box";
import { CustomBox } from "./customBox";
import ServiceInfo from "../../../../../constants/models/serviceInfo";
import { ConnectionTypes } from "../../../../../constants/utils/connectionTypes";
import { LoadingState } from "../../../../../_common/loadingState";

export const DefaultService = ({ connectionType, serviceTitle, serviceDetailedDescription, serviceType }) => {
	const services = useSelector((state) => state.services);
	const dispatch = useDispatch();
	const servicesRef = useRef(null);
	const [serviceOnFocus, setServiceOnFocus] = useState(undefined);
	const [searchPage, setSearchPage] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [resetPage, setResetPage] = useState(false);
	const [contractReference, setContractReference] = useState({});
	const [searchFilter, setSearchFilter] = useState([]);
	const [loadedServices, setLoadedServices] = useState([]);
	const [canFillContract, setCanFillContract] = useState(false);
	const [extraItems, setExtraItems] = useState(0);
	const [showCustomBox, setShowCustomBox] = useState(false);
	const [loadMore, setLoadMore] = useState(false);
	const [currentConnectionType, setCurrentConnectionType] = useState(connectionType);

	function updateLoadedItems(data) {
		if (!R.isNil(data.items) && data.items.length > 0) {
			if (currentConnectionType != connectionType) {
				setLoadedServices(data.items.map((e) => new ServiceInfo(e)));
				return;
			}

			let tmpLoadedServices = [...loadedServices];
			data.items.forEach((d) => {
				const existingIndex = tmpLoadedServices.findIndex((i) => i.name === d.name);
				if (existingIndex === -1) {
					tmpLoadedServices.push(new ServiceInfo(d));
				} else {
					const newService = new ServiceInfo(d);
					newService.branches.forEach((newBranch) => {
						if (tmpLoadedServices[existingIndex].branches.findIndex((b) => b.id === newBranch.id) === -1) {
							tmpLoadedServices[existingIndex].branches.push(newBranch);
						}
					});
				}
			});
			setLoadedServices(tmpLoadedServices);
		} else if (serviceType === "LogementProprietaire" && customServiceDatas.length === 0) {
			setShowCustomBox(true);
		}
	}

	useEffect(() => {
		setContractReference({});
		setServiceOnFocus({});
		setSearchFilter([]);
		setSearchPage(0);
		setCurrentPage(1);
		setResetPage(true);

		setCanFillContract(false);
		setExtraItems(0);
		setShowCustomBox(false);
		setLoadedServices([]);
		if (!R.isNil(connectionType)) {
			setCurrentConnectionType(connectionType);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [connectionType]);

	useEffect(() => {
		setTimeout(() => {
			setResetPage(false);
		}, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resetPage]);

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	});

	async function loadNotVisibleUserServices() {
		let extra = 0;
		for (const serviceData of services.serviceData[connectionType]) {
			if (serviceData.serviceId.startsWith("Custom")) continue;
			if (loadedServices.find((service) => service.branches.findIndex((b) => b.id === serviceData.serviceId) !== -1) === undefined) {
				let response = await dispatch(getServiceById(connectionType, serviceData.serviceId));

				if (Array.isArray(response) === false) {
					response = { items: [response] };
				}
				updateLoadedItems(response);
				extra++;
			}
		}
		setExtraItems(extra);
	}

	useEffect(() => {
		if (canFillContract === true) {
			let tmpContracts = {};
			if (!R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType])) {
				services.serviceData[connectionType].forEach((serviceData) => {
					tmpContracts[serviceData.serviceId] = serviceData.payload.reference;
					// switch (connectionType){
					//     case ConnectionTypes.insurance:
					//         if (R.isNil(tmpContracts[serviceData.serviceId])){
					//             tmpContracts[serviceData.serviceId] = [];
					//         }
					//         serviceData.payload.insuredItems.forEach(sd => {
					//             if (sd !== 'boat' && sd !== 'car' && sd !== 'moto' && sd !== 'scooter'){
					//                 tmpContracts[serviceData.serviceId]["other"] = sd;
					//             }
					//             else {
					//                 tmpContracts[serviceData.serviceId].push(sd);
					//             }
					//         });
					//         break;
					//     default:
					//         tmpContracts[serviceData.serviceId] = serviceData.payload.reference;
					//         break;
					// }
				});
			}
			setContractReference(tmpContracts);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [canFillContract, !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].length]);

	const handleClickOutside = (event) => {
		if (servicesRef.current && !servicesRef.current.contains(event.target)) {
			setServiceOnFocus(undefined);
			setSearchPage(0);
		}
	};

	if (canFillContract === false && !R.isNil(loadedServices) && loadedServices.length > 0 && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType])) {
		loadNotVisibleUserServices();
		setCanFillContract(true);
	}
	if (canFillContract === false && !R.isNil(services.serviceData) && R.isNil(services.serviceData[connectionType])) {
		setCanFillContract(true);
	}

	let allBranches = [];
	if (!R.isNil(loadedServices) && canFillContract === true) {
		R.sortWith([R.ascend(R.prop("nameNoAccents"))])(loadedServices)
			.filter((s) => s.branches.length !== 0)
			.forEach((s) => {
				s.branches.forEach((branch) => {
					let a = R.isNil(branch.name) ? "" : branch.name.toLowerCase();
					let b = R.isNil(branch.address.addressLocality) ? "" : (!R.isNil(branch.address.postalCode) ? branch.address.postalCode + " " : "") + branch.address.addressLocality.toLowerCase();
					let c = R.isNil(branch.address.streetAddress) ? "" : branch.address.streetAddress.toLowerCase();
					let normalizedNameAndAddress = removeAccents(a).replace(/\s/gi, "") + "(" + removeAccents(b).replace(/\s/gi, "") + ")" + removeAccents(c).replace(/\s/gi, "");
					let hide = searchFilter.length > 0 ? true : false;
					searchFilter.length > 0 &&
						searchFilter.forEach((f) => {
							if (normalizedNameAndAddress.includes(removeAccents(f.value.toLowerCase()).replace(/\s/gi, "")) && (!R.isNil(f.address) ? normalizedNameAndAddress.includes(removeAccents(f.address.toLowerCase()).replace(/\s/gi, "")) : true)) {
								hide = false;
							}
						});
					if (hide !== true) {
						let inputOnFocus = branch.id === serviceOnFocus;
						let withServiceData = !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].findIndex((s) => s.serviceId === branch.id) !== -1;
						let isCollapsed = !(inputOnFocus || (!R.isNil(contractReference[branch.id]) && (connectionType === ConnectionTypes.insurance ? contractReference[branch.id].length > 0 : contractReference[branch.id] !== ""))) && !withServiceData;
						allBranches.push({ isCollapsed: isCollapsed, branch: branch, inputOnFocus: inputOnFocus, withServiceData: withServiceData });
					}
				});
			});
	}

	let customServiceDatas = null;
	let customServiceIdList = [];
	if (!R.isNil(services.serviceData[connectionType])) {
		services.serviceData[connectionType]
			.filter((s) => !R.isNil(s.serviceId) && s.serviceId !== "" && s.serviceId.toLowerCase().startsWith("custom"))
			.forEach((srv) => {
				if (customServiceDatas === null) {
					customServiceDatas = [];
				}
				if (!customServiceIdList.includes(srv.serviceId)) {
					customServiceDatas.push(srv);
					customServiceIdList.push(srv.serviceId);
				}
			});
	}

	return (
		<article className="block" id={serviceTitle}>
			<h3 className="sr-only visually-hidden">{serviceTitle}</h3>
			<section className="card card-body">
				<div className="block">
					{serviceTitle ? (
						<div className={"grid-sm grid-sm-1 grid-md-3 gx-1 align-items-center" + (!R.isNil(loadedServices) ? " mb-0" : " mb-sm")}>
							<div className="block my-auto">
								<h5 className="h4 text-uppercase text-secondary font-weight-black mt-auto mb-0">{serviceTitle}</h5>
								<p className="mb-auto fs-3 o-80">{serviceDetailedDescription}</p>
							</div>
							<div className="ml-md-auto grid-column-md-2">
								<button
									type="button"
									className="btn p-0 align-middle text-gray no-outline text-md-right"
									onClick={(e) => {
										e.preventDefault();
										setShowCustomBox(true);
									}}>
									Cliquez ici si vous ne trouvez pas votre <span className="text-uppercase">{serviceTitle}</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
								</button>
							</div>
						</div>
					) : (
						""
					)}
					<div className="form-group mb-0 py-3 bg-white sticky-top">
						<SearchService connectionType={connectionType} searchPage={searchPage} setSearchPage={setSearchPage} searchFilter={searchFilter} setSearchFilter={setSearchFilter} setCurrentPage={setCurrentPage} updateLoadedItems={updateLoadedItems} setLoadMore={setLoadMore} />
					</div>
					{showCustomBox ? <CustomBox key={"custom"} boxIndex={"custom"} connectionType={connectionType} customServiceData={null} setServiceOnFocus={setServiceOnFocus} inputOnFocus={null} setShowCustomBox={setShowCustomBox} setSearchFilter={setSearchFilter} /> : ""}
					<p className="fs-3 text-gray">Sélectionner un ou plusieurs organismes en cliquant sur les éléments ci-dessous.</p>
					{loadedServices.length === 0 && serviceType !== "LogementProprietaire" ? <LoadingState /> : ""}
					<div className={"grid-sm grid-md-min grid-lg-tight grid-lg-4 mt-3"} ref={servicesRef}>
						{R.isNil(customServiceDatas)
							? ""
							: customServiceDatas.map((customServiceData, index) => {
									return <CustomBox key={"custom" + index} boxIndex={"custom" + index} connectionType={connectionType} customServiceData={customServiceData} setServiceOnFocus={setServiceOnFocus} inputOnFocus={null} setShowCustomBox={setShowCustomBox} isActive={true} setSearchFilter={setSearchFilter} />;
							  })}

						{!R.isNil(allBranches) && allBranches.length > 0
							? R.sortWith([R.descend(R.prop("withServiceData"))])(allBranches).map((b, index) => {
									let isCollapsed = b.isCollapsed;
									if (allBranches.length === 1) {
										isCollapsed = false;
									}
									return (
										<Box
											key={index + b.branch.id}
											boxIndex={b.branch.id}
											connectionType={connectionType}
											isCollapsed={isCollapsed}
											setServiceOnFocus={setServiceOnFocus}
											branch={b.branch}
											contractReference={contractReference}
											setContractReference={setContractReference}
											inputOnFocus={b.inputOnFocus}
											setSearchFilter={setSearchFilter}
										/>
									);
							  })
							: ""}
					</div>
					{loadMore ? (
						<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-white pt-3 pb-2">
							<h4 className="sr-only visually-hidden">Plus</h4>
							<button
								onClick={async () => {
									let response = await dispatch(fetchServices(connectionType, currentPage));
									if (response.items.length < 100) {
										setLoadMore(false);
									} else {
										setLoadMore(true);
									}
									updateLoadedItems(response);
									setCurrentPage(currentPage + 1);
								}}
								type="button"
								className="btn btn-icon btn-alert-light mx-auto py-2">
								<i className="eva eva-more-horizontal-outline h3 my-auto mr-2"></i>Plus
							</button>
						</footer>
					) : (
						""
					)}
				</div>
			</section>
		</article>
	);
};
